import { useParams } from 'react-router'
import { ChatWorkbench } from './ChatPage'

export function ChatWithAgentPage() {
  const params = useParams<{ agentId: string }>()
  return <ChatWorkbench selectedAgentId={params.agentId} />
}
